import React from "react";
import css from "./Blog.module.css";

const Blog = () => {
	return (
		<section className={css.blog}>
			<h2>Blog</h2>
			<p>Blog page</p>
		</section>
	);
};

export default Blog;
